<template>
  <v-dialog v-model="open" max-width="80vw" @click:outside="close">
    <v-card>
      <!-- Usamos TU formulario de creación de ventas y lo rellenamos vía $refs -->
      <CreateSaleForm
        v-if="open"
        ref="form"
        :message="messageFromContext"
        @closeCreateDialogQuotation="onSaved"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
// Ajusta esta ruta si tu formulario vive en otro lugar
import CreateSaleForm from '../quotations/create'

export default {
  name: 'DuplicateSale',
  components: { CreateSaleForm },
  props: {
    value: { type: Boolean, default: false },
    saleId: { type: [Number, String], required: true },
    sourceSale: { type: Object, default: null },
  },
  data: () => ({
    open: false,
    raw: null,
    mapped: null,
  }),
  computed: {
    messageFromContext() {
      if (!this.mapped) return [null, 'vendido']
      return [this.mapped.brand_id || null, this.mapped.sale_status || 'vendido']
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (v) {
        this.open = v
        if (v) this.bootstrap()
      }
    }
  },
  methods: {
    titleByStatus(s) {
      if (s === 'vendido' || s === 'pedido') return 'Venta'
      if (s === 'quotation') return 'Cotización'
      return 'Venta'
    },
    close() {
      this.$emit('input', false)
    },
    onSaved(payload) {
      this.$emit('input', false)
      this.$emit('duplicated', payload)
    },
    async bootstrap() {
      try {
        const base = this.sourceSale || (await this.fetchSale(this.saleId))
        this.raw = base
        this.mapped = this.normalizeForDuplicate(base)
        this.$nextTick(() => this.prefillChild())
      } catch (e) {
        console.error(e)
        this.$emit('input', false)
      }
    },
    fetchSale(id) {
      const url = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/sales?filter[id]=' + id
      return axios.get(url).then(r => r.data.data[0])
    },

    prefillChild() {
        const f = this.$refs.form
        if (!f || !this.mapped) return

        // Si hay monto en dólares, activa el switch del hijo
        f.dolares = Number(this.mapped.dollar_amount || 0) > 0

        f.quotation = {
            ...f.quotation,
            campaign_contact_id: this.mapped.campaign_contact_id || null,
            finance_contact_id:  this.mapped.finance_contact_id || null,
            email:               this.mapped.email || '',
            brand_id:            this.mapped.brand_id || null,
            agency_id:           this.mapped.agency_id || null,
            user_id:             this.mapped.user_id || (f.currentUser && f.currentUser.id) || '',

            // ¡NO vaciar archivos si no quieres! Normalmente no se “copian” archivos,
            // pero si SOLO querías ver el número de factura, está bien dejar pdfs vacíos:
            pdfs: [],

            description:         this.mapped.description || '',
            sale_status:         this.mapped.sale_status || 'vendido',

            parent_id: this.mapped.parent_id || this.mapped.id,

            // Respeta el tipo de factura y la factura:
            sale_type:           this.mapped.sale_type || '',
            invoice:             this.mapped.invoice || '',           // <--- AHORA SÍ

            influencer_id:       this.mapped.influencer_id || '',
            service_date:        this.mapped.service_date || '',
            service:             this.mapped.service || '',
            subtotal:            Number(this.mapped.subtotal || 0),

            // deja total vacío para que tu cálculo lo haga al guardar (o calcula aquí si prefieres)
            total:               '',

            influencer_amount:   Number(this.mapped.influencer_amount || 0),
            campaign:            this.mapped.campaign || '',

            // Fechas
            payment_promise_date:this.mapped.payment_promise_date || '',
            deadline_date:       this.mapped.deadline_date || '',
            invoice_date:        this.mapped.invoice_date || '',      // <--- AHORA SÍ

            // Dólares
            dollar_amount:       Number(this.mapped.dollar_amount || 0),

            // Archivos: usualmente NO se duplican
            invoice_file:        '',
            peach_invoice_file:  '',

            due_date:            this.mapped.due_date || '',
            needs_authorization: false,
            in_credit:           (typeof this.mapped.in_credit === 'boolean') ? this.mapped.in_credit : true,
            code:                '',
            type:                this.mapped.type || '',
            brand_guideline:     this.mapped.brand_guideline || '',
            talent_guideline:    this.mapped.talent_guideline || '',
            exclusiveness:       this.mapped.exclusiveness || '',
            image_use:           this.mapped.image_use || '',
            payment_terms:       this.mapped.payment_terms || '',
        }

        // Catálogos que el form usa para pintar opciones ya cargadas
        f.entriesAgencies    = this.mapped._entries?.agencies        || []
        f.entriesBrands      = this.mapped._entries?.brands          || []
        f.entriesInfluencers = this.mapped._entries?.influencers     || []
        f.agency_contacts    = this.mapped._entries?.agency_contacts || []
        f.credit_amount      = this.mapped._entries?.credit_amount   || 0

        // Estado visual del form hijo
        f.enable_expense = false
        f.expenses = [{
            percentage_over_sale:'',
            concept:'',
            influencer_id:'',
            user_id:'',
            payment_date:'',
            deadline_date:'',
            amount:'',
            datePicker:false,
            status:'activo'
        }]
        },

    
    normalizeForDuplicate(src) {
        function num (v) { return (v==null || v==='') ? 0 : Number(v) }

        const parentId = src?.parent_id ? src.parent_id : src?.id;

        const agency   = src?.agency || {}
        const brand    = src?.brand || {}
        const infl     = src?.influencer || {}
        const agent    = src?.agent || {}
        const finance  = src?.finance_contact || {}
        const campaign = src?.campaign_contact || {}

        const agencies = agency.id ? [{
            id: agency.id,
            name: agency.name,
            phone: agency.phone,
            email: agency.email,
            credit_limit: agency.credit_limit || 0,
            credit_days: agency.credit_days || 0,
            contacts: Array.isArray(agency.contacts) && agency.contacts.length
            ? agency.contacts
            : [
                ...(finance.id  ? [{ id: finance.id,  name: finance.name,  last: finance.last,  email: finance.email,  phone: finance.phone,  job_position: finance.job_position }] : []),
                ...(campaign.id ? [{ id: campaign.id, name: campaign.name, last: campaign.last, email: campaign.email, phone: campaign.phone, job_position: campaign.job_position }] : [])
                ]
        }] : []

        const brands = brand.id ? [{ id: brand.id, name: brand.name }] : []

        const influencers = infl.id ? [{
            id: infl.id,
            social_networks: infl.social_networks || { instagram: (infl.name || infl.handle || '') },
            is_booking: !!infl.is_booking,
            commission_percentage: infl.commission_percentage || 0
        }] : []

        const agency_contacts = agencies.length ? (agencies[0].contacts || []) : []

        return {
            agency_id: agency.id || null,
            brand_id: brand.id || null,
            user_id: agent.id || null,

            influencer_id: infl.id || '',
            influencer_amount: num(src?.influencer_amount),
            campaign: src?.campaign || '',
            service_date: src?.service_date || '',
            service: src?.service || '',
            subtotal: num(src?.subtotal),

            // Campos que faltaban:
            sale_type: src?.sale_type || '',        // 'Serie A' | 'Serie B' (según tu UI)
            invoice: src?.invoice || '',            // <--- IMPORTANTE
            invoice_date: src?.invoice_date || '',  // <--- IMPORTANTE

            code: '',
            type: src?.type || '',
            deadline_date: src?.deadline_date || '',
            payment_promise_date: src?.payment_promise_date || '',
            due_date: src?.due_date || '',
            dollar_amount: num(src?.dollar_amount),
            in_credit: (typeof src?.in_credit === 'boolean') ? !!src.in_credit : true,

            campaign_contact_id: campaign.id || null,
            finance_contact_id:  finance.id || null,
            email: finance.email || '',
            description: src?.description || '',
            brand_guideline: src?.brand_guideline || '',
            talent_guideline: src?.talent_guideline || '',
            exclusiveness: src?.exclusiveness || '',
            image_use: src?.image_use || '',
            payment_terms: src?.payment_terms || '',

            sale_status: src?.sale_status || 'vendido',

            parent_id: parentId,

            _entries: {
            agencies,
            brands,
            influencers,
            agency_contacts,
            credit_amount: agencies.length ? (agencies[0].credit_limit || 0) : 0,
            }
        }
    }

  }
}
</script>
